/* PrivacidadRedirect.jsx
   Ruta pública en /privacidad que sirve el archivo estático
   /privacidad.html (publicado en /app/frontend/public/).
   Se hace via redirect inmediato para que ambas URLs funcionen:
     - dmu614.com/privacidad         (URL bonita)
     - dmu614.com/privacidad.html    (acceso directo al archivo)
*/
import { useEffect } from "react";

export default function PrivacidadRedirect() {
  useEffect(() => {
    window.location.replace("/privacidad.html");
  }, []);
  return (
    <div style={{ padding: 40, fontFamily: "sans-serif", textAlign: "center", color: "#475569" }}>
      Cargando política de privacidad…
    </div>
  );
}
